import { usePathname } from 'next/navigation'
import { useCallback, useMemo } from 'react'

import useClevertapEvent from '../index'

const useClevertapForLoginBanner = () => {
    const { triggerEvent } = useClevertapEvent()
    const pathname = usePathname()

    const page_name = useMemo(() => {
        if (pathname?.includes('/itinerary')) return 'flights_itinerary'
        return 'flights_srp'
    }, [pathname])

    const triggerLoginBannerClickEvent = useCallback(() => {
        triggerEvent('Air_UI_Action', {
            action_name: 'login_banner_click',
            action_type: 'BUTTON',
            page_name
        })
    }, [triggerEvent, page_name])

    return { triggerLoginBannerClickEvent }
}

export default useClevertapForLoginBanner
